module.exports = __webpack_public_path__ + "static/rocket-f9481a366e60131eddac09e3faaac0a0.svg";